<template>
  <FormContainer class="forgot-password__form-container">
    <div class="forgot-password__text-block">
      <h2 class="forgot-password__title">Відновлення паролю</h2>
      <p class="forgot-password__description">На пошту {{ getResetEmail }} відправлено лист з подальшою інструкцією для відновлення пароля. Не отримали листа?</p>
      <p class="forgot-password__link">
        <SmartLink
          class="forgot-password__resend-link"
          v-if="sendDelay === null"
          :method="resentResetLink"
        >
          <SpinnerLoader v-if="false" />Надіслати ще раз
        </SmartLink>
        <span class="forgot-password__resend-delay-text" v-else>Відправити ще раз можна буде через {{ getExpirationText(sendDelay, getSecondsExpirationForms) }}</span>
      </p>
    </div>
    <TransparencyFancyButton
      class="forgot-password__login-link"
      :route="{ name: 'login' }"
    >
      Повернутися до входу
    </TransparencyFancyButton>
  </FormContainer>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { secondsForms } from '@/shared/config/expiration-forms';
import { expirationText } from '@/shared/lib/string';
import { FormContainer } from '@/shared/ui/account';
import { TransparencyFancyButton } from '@/shared/ui/form';
import { SmartLink } from '@/shared/ui/link';
import { SpinnerLoader } from '@/shared/ui/loader';

export default {
  data() {
    return {
      delayTimer: null,
      sendDelay: null,
    };
  },
  async mounted() {
    this.sendDelay = await this.getTimeUntilNextRequest();
    this.runDelayTimer();
  },
  mixins: [ expirationText ],
  components: { FormContainer, SmartLink, SpinnerLoader, TransparencyFancyButton },
  computed: {
    ...mapGetters('resetLinkEmailModule', [
      'isLoadingResetLink', 'isResetLinkError', 'getResetLinkErrorMessage', 'getResetEmail', 'canSendNewResetLinkRequest',
    ]),
    getSecondsExpirationForms() {
      return secondsForms.forms;
    },
  },
  methods: {
    ...mapActions('resetLinkEmailModule', ['sendResetLink', 'getTimeUntilNextRequest']),
    clearError(field) {
      this.errors[field] = '';
    },
    runDelayTimer() {
      this.delayTimer = setInterval(() => {
        if (this.sendDelay > 1) {
          this.sendDelay--;
        } else {
          clearInterval(this.delayTimer);
          this.sendDelay = null;
          this.delayTimer = null;
        }
      }, 1000);
    },
    resentResetLink() {
      this.sendResetLink(this.getResetEmail);
      this.sendDelay = this.getTimeUntilNextRequest();
      this.runDelayTimer();
    },
  },
};
</script>

<style lang="scss" scoped>
.forgot-password {
  &__form-container {
    margin: 170px auto 0;
    width: 600px;

    @media (max-width: 630px) {
      margin: 50px 16px 0;
      width: auto;
    }
  }

  &__title {
    font-family: "IBM Plex Sans", sans-serif;
    font-size: 36px;
    font-weight: 400;
    color: #0C1421;
    text-align: center;
    margin-bottom: 16px;

    @media (max-width: 630px) {
      font-size: 24px;
    }
  }

  &__description {
    font-size: 18px;
    font-weight: 400;
    color: #313957;
    text-align: center;
    margin-bottom: 0;

    @media (max-width: 630px) {
      font-size: 14px;
    }
  }

  &__link {
    text-align: center;
    margin-bottom: 32px;
  }

  &__resend-link {
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #6171E4;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

  &__resend-delay-text {
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #6171E4;
  }

  &__login-link {
    width: 100%;
  }
}
</style>
